const trackTitle = 'Contractor Subscriptions'

const track = (action, otherData = {}) => {
  Track.send(trackTitle, Object.assign({ action }, otherData))
}

export const propertySearch = () => {
  track('property search')
}
